import React, {useCallback, useContext, useId, useMemo} from 'react';


import {WidthItem} from 'src/components/width-item';
import {useDateTime} from 'src/hooks/date-time/useDateTime';
import {dateToDateString} from 'src/hooks/date-time/utils';
import {mapDateFormat} from 'src/utils/mapDateFormat';

import {Calendar} from '@pb/kit-component-calendar';
import Label from '@pb/kit-component-label';
import {LocaleContext} from '@pb/kit-context-locale';


type Props = {
    id: string,
    selectedDate: string,
    onChange: (date: string) => void,
    clearable?: boolean,
    minDate?: Date,
    width?: number,
    readonly?: boolean,
    disabled?: boolean,
    label?: React.ReactNode,
};

export const DateInput = (props: Props) => {
    const {
        id,
        selectedDate,
        onChange,
        clearable,
        minDate,
        width,
        readonly,
        disabled,
        label,
    } = props;

    const labelId = useId();
    const {locale} = useContext(LocaleContext);
    const {getLocalDate} = useDateTime();

    const onChangeDate = useCallback((changedDate: Date | undefined) => {
        onChange(changedDate ? dateToDateString(changedDate) : '');
    }, [onChange]);

    const date = useMemo(() => {
        if (!selectedDate) {
            return undefined;
        }

        return getLocalDate(selectedDate);
    }, [selectedDate, getLocalDate]);

    return (
        <WidthItem width={width}>
            {label ? (
                <Label id={labelId}>
                    {label}
                </Label>
            ) : null}
            <Calendar
                id={id}
                disabled={disabled}
                readOnly={readonly}
                dateFormat={mapDateFormat(locale.dateFormat, 'CALENDAR')}
                aria-labelledby={label ? labelId : undefined}
                selected={date}
                onChange={onChangeDate}
                isClearable={clearable}
                minDate={minDate}
            />
        </WidthItem>
    );
};
